import { makeStyles } from 'makeStyles';
import { TEXT_GREEN } from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  listWrapper: {
    backgroundColor: theme.palette.grey[400],
    marginTop: 30,
    padding: 20,
  },
  listItemWrapper: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 3,
    padding: 18,
  },
  listItemNameTypography: {
    fontSize: 15,
    fontWeight: 500,
  },
  listItemDescriptionTypography: {
    color: theme.palette.grey[50],
    fontSize: 13,
  },
  listItemIcon: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  avoidanceRuleOrGroupIcon: {
    alignSelf: 'center',
  },
  viewGroup: {
    alignSelf: 'center',
    color: TEXT_GREEN,
    textDecoration: 'underline',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  viewGroupAction: {
    color: TEXT_GREEN,
  },
}));
